const apiUrl = process.env.REACT_APP_API_URL;
export const PostJutgePracticaIdUsuariIdPenality = async (id_practica: string, id_usuari: string, json: any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/practica/${id_practica}/usuaris/${id_usuari}/penality`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(json)
            });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
